<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-5">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0">
                        
                        <template>
                            <div class="text-center text-muted mb-4">
                                <small>Ingrese con su correo y contraseña</small>
                            </div>
                            <form role="form">
                                <base-input alternative
                                            class="mb-3"
                                            placeholder="Correo"
                                            addon-left-icon="ni ni-email-83"
                                            v-model="form.email">
                                </base-input>
                                <base-input alternative
                                            type="password"
                                            placeholder="Contraseña"
                                            addon-left-icon="ni ni-lock-circle-open"
                                            v-model="form.password">
                                </base-input>
                                
                                <div class="text-center">
                                    <base-button type="primary" class="my-4" @click="login">Ingrese</base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                    <div class="row mt-3">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    data(){
        return {
            form:{
				email:'',
                password:''
			}
        }
    },
    methods:{
        login(){
            this.$store.dispatch('auth/login',this.form).then(response => {		
                        // this.$store.commit('SET_OVERLAY', true);
						this.$router.push({ path: '/dashboard'});
	        		}).catch(e => {
						console.log(e);
	        		});	
        },
    }
};
</script>
<style>
</style>
